/** Same smart-auth landing as `/`; use this path for stable bookmarks and external links. */
import { createFileRoute } from "@tanstack/react-router";

import { PublicSmartAuthLanding } from "@/features/auth/components/PublicSmartAuthLanding";
import { smartAuthLandingSearchSchema } from "@/features/auth/search/authRouteSearch";

const AuthenticatePage = () => {
    return <PublicSmartAuthLanding search={Route.useSearch()} />;
};

export const Route = createFileRoute("/_auth/_public/authenticate")({
    component: AuthenticatePage,
    validateSearch: (search) => smartAuthLandingSearchSchema.parse(search ?? {}),
});
